import { BaseJob } from "~/components/build/Show/lib/types/BaseJob";
import { JobStates } from "~/components/build/Show/lib/types/JobStates";

export function isTriggerJob(value: unknown): value is TriggerJob {
  return typeof value === "object" && value !== null && "type" in value && value.type === "trigger";
}

export interface TriggerJob extends BaseJob {
  type: "trigger";
  id: string;
  name?: string;
  state: JobStates;
  passed?: boolean | null | undefined;
  step?: {
    label: string | null | undefined;
  };
  triggerProjectSlug?: string | null | undefined;
  triggerProject?: {
    name: string;
  };
  groupUuid: string | null | undefined;
  groupLabel: string | null | undefined;
  groupIdentifier: string | null | undefined;
  stepUuid: string;
  retriedInJobUuid?: string;
  softFailed?: boolean;
  tooltip?: string;
  triggerAsync: boolean | null | undefined;
  triggerBranch: string;
  triggerCommit: string;
  triggerCommitShortLength: number;
  triggerFailedReason: string | null | undefined;
  triggeredBuild?: {
    number: number;
    destroyedAt?: string;
    url: string;
    canvasUrl: string;
    stepsUrl: string;
    streamName: string;
    streamTargetDomId: string;
    stepsStreamDomId: string;
  };
  triggeredBuildDeleted?: boolean;
  retryPending: boolean;
  createdAt: string;
  startedAt?: string | null;
  finishedAt?: string | null;
  canceledAt?: string | null;
  timedOutAt?: string | null;
  runnableAt?: string | null;
  expiredAt?: string | null;
  path: string;
}
